export default __webpack_public_path__ + "static/media/ijert_certificate1.a5bae523.png";